import CUIContainer from 'connect-dot-com-ui-components/Components/CUIContainer/CUIContainer';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import HomepageHeaderContent from '../../HomepageHeaderContent';
import SiteFooter from '../SiteFooter';
import SiteHeader from '../SiteHeader';
import DownloadButton from '../../AppDownload/DownloadButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HomepageLayout = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(CUIFlex, {
    direction: "column",
    flex: "1",
    minHeight: "100%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top",
    backgroundSize: "105%",
    style: {
      backgroundImage: `linear-gradient(106.61deg, #F8E1EC 0%, #FDF3F3 100%)`
    },
    children: [/*#__PURE__*/_jsx(SiteHeader, {
      children: /*#__PURE__*/_jsx(HomepageHeaderContent, {})
    }), /*#__PURE__*/_jsx(CUIContainer, {
      bgColor: "white",
      flex: 1,
      maxWidth: "none",
      paddingX: 0,
      width: "100%",
      children: children
    }), /*#__PURE__*/_jsx(SiteFooter, {}), /*#__PURE__*/_jsx(DownloadButton, {})]
  });
};
export default HomepageLayout;